import Vue from 'vue'
import VueRouter from 'vue-router'
import { commonRouter } from "./routes"
import { getStorage, setStorage } from '@/storage'
import { initRouter } from "./routes"
import store from '@/store'

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: commonRouter
})
Vue.use(VueRouter)

router.beforeEach((to, from, next) => {
  console.log(to)
  if (to.path != '/home/index' && to.path != '/login') {
    let str = {
      path: to.path,
      title: to.meta.title,
    }
    store.commit('setRouterArr', str);//存储点击过的二级菜单（在顶部部展示）
    let arr = getStorage('routerArr') || []

    let o = arr.some(item => {
      return item.path == to.path;
    })
    !o && arr.push(str)
    setStorage('routerArr', arr)

  }
  let token = getStorage('token')
  if (token) {
    if (router.options.routes.length <= 4) {
      initRouter()
      setTimeout(() => {
        next(to.path)
      }, 1)
      // next(to.path)
    } else {
      to.path === "/login" ? next('/home/index') : next()
    }
  } else {
    to.path === "/login" ? next() : next('/login') // /login
  }
})
export default router
